/** Mirrors backend/app/tickets/storage.py so people hear about a bad file before uploading. */

export const MAX_FILE_BYTES = 10 * 1024 * 1024;
export const MAX_FILES = 5;
export const ALLOWED_EXTENSIONS = [
  ".png",
  ".jpg",
  ".jpeg",
  ".gif",
  ".webp",
  ".pdf",
  ".txt",
  ".log",
  ".csv",
  ".docx",
  ".xlsx",
  ".pptx",
];
export const ACCEPT = ALLOWED_EXTENSIONS.join(",");

export function fileProblem(file: File): string | null {
  const dot = file.name.lastIndexOf(".");
  const ext = dot >= 0 ? file.name.slice(dot).toLowerCase() : "";
  if (!ALLOWED_EXTENSIONS.includes(ext)) return `${file.name}: this type of file can't be attached.`;
  if (file.size === 0) return `${file.name} is empty.`;
  if (file.size > MAX_FILE_BYTES) return `${file.name} is larger than 10 MB.`;
  return null;
}
